import React from 'react';
import TablaSolicitudFraccionamiento from './Tablas/TablaSolicitudFraccionamiento';
import GraficoSolicitudFraccionamiento from './Graficos/GraficoSolicitudFraccionamiento';
import { VStack, Heading } from '@chakra-ui/react';
import ObrasFraccionamientoDashboard from './Dashboard/ObrasFraccionamientoDashboard';

const ObrasFraccionamiento: React.FC = () => {
  return (
    <VStack spacing={8} align="stretch">
      <Heading size="lg" textAlign="center" color="blue.700">
        Fraccionamiento
      </Heading>
      <ObrasFraccionamientoDashboard/>
      <TablaSolicitudFraccionamiento />
      {/* <GraficoSolicitudFraccionamiento /> */}
    </VStack>
  );
};

export default ObrasFraccionamiento;
